import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { TreoMessage } from '@treo/components/message';

enum InviteType {
  JOIN_COMPANY = 'join_company',
  CREATE_COMPANY = 'create_company',
}

@Component({
  selector: 'ew-invite-new-user',
  templateUrl: './invite-new-user.component.html',
  styleUrl: './invite-new-user.component.scss',
})
export class InviteNewUserComponent {
  treoMessage: TreoMessage = {
    appearance: 'outline',
    type: 'warning',
    showButtonClose: false,
    showIcon: true,
    customIcon: '',
    title: '',
    content: 'settingsUser:alertAdminAccess',
  };
  unlockSend: boolean = true;
  newUser = new FormGroup({
    fullName: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    public dialogRef: MatDialogRef<InviteNewUserComponent>,
    private API: ApiService,
  ) {}

  get validations(): boolean {
    return this.newUser.valid && this.unlockSend;
  }

  submit() {
    this.API.post('auth/invitation', {
      ...this.newUser.value,
      type: InviteType.JOIN_COMPANY,
    }).subscribe(
      (_value) => {
        this.unlockSend = false;
        this.API.alertService.success('alert:invitationSent');
        this.dialogRef.close('invite');
      },
      ({ error: error }) => {
        this.API.alertService.error(
          `alert:invitationError${error.message}`,
          error,
        );
        this.unlockSend = true;
      },
    );
  }
}
